import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { includes } from "ramda";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Menu,
  MenuItem,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
  button: {
    color: theme.palette.primary.darker,
    fontWeight: "normal",
  },

  icon: {
    "& > :first-child": {
      fontSize: "1.4rem",
      marginTop: 4,
    },
  },
}));

const ContentGroupTypeSelect = ({ selectedTypes, handleTypeChange }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleTypeClose = event => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  return (
    <FormControl>
      <Button
        classes={{ root: classes.button, iconSizeMedium: classes.icon }}
        onClick={handleClick}
        endIcon={<KeyboardArrowDown fontSize="small" />}
      >
        Types
      </Button>
      <Menu
        id="filter-content-groups"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleTypeClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={event => event.stopPropagation()}>
          <FormControlLabel
            label="Module"
            control={
              <Checkbox
                onChange={handleTypeChange("MODULE")}
                checked={includes("MODULE", selectedTypes)}
                color="primary"
              />
            }
          />
        </MenuItem>
        <MenuItem onClick={event => event.stopPropagation()}>
          <FormControlLabel
            label="Anthology"
            control={
              <Checkbox
                onChange={handleTypeChange("ANTHOLOGY")}
                checked={includes("ANTHOLOGY", selectedTypes)}
                color="primary"
              />
            }
          />
        </MenuItem>

        <MenuItem onClick={event => event.stopPropagation()}>
          <FormControlLabel
            label="Collection"
            control={
              <Checkbox
                onChange={handleTypeChange("COLLECTION")}
                checked={includes("COLLECTION", selectedTypes)}
                color="primary"
              />
            }
          />
        </MenuItem>
      </Menu>
    </FormControl>
  );
};

export default ContentGroupTypeSelect;
